import { FiMenu, FiX } from "react-icons/fi";
import React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import { sidebarHide, sidebarShow } from "actions/sidebarActions";
import type { RootState } from "types/state";

const mapStateToProps = (state: RootState) => {
  return {
    showSidebar: state.sidebar.showSidebar,
  };
};

const mapDispatchToProps = {
  sidebarShow,
  sidebarHide,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

// Parent passes nothing — all props (showSidebar / sidebarHide / sidebarShow)
// are injected by redux, and `client` by withApollo. No OwnProps to add.
type SideBarToggleButtonProps = PropsFromRedux;

const SideBarToggleButton = ({
  showSidebar,
  sidebarHide,
  sidebarShow,
}: WithApolloClient<SideBarToggleButtonProps>) => {
  return (
    <div className="portfolio-sm-screen">
      <div className="responsive-menu">
        {!showSidebar && (
          <span className="menu-icon">
            <FiMenu
              stroke={"#FFFFFF"}
              size={24}
              strokeWidth={"1"}
              onClick={() => {
                sidebarShow();
              }}
            />
          </span>
        )}

        {showSidebar && (
          <span
            className="close-x-icon"
            onClick={() => {
              sidebarHide();
            }}
          >
            <FiX size={24} strokeWidth={"1.5"} />
          </span>
        )}
      </div>
    </div>
  );
};

export default connector(
  withApollo<SideBarToggleButtonProps>(SideBarToggleButton)
);
